"use client";
import type { ReactElement } from "react";
import type { TimelinePeriod as TimelinePeriodType } from "./timeline-types";
const COMPACT_PREVIEW_PERIOD_LIMIT = 8;
const COMPACT_PREVIEW_TRACK_INSET = 8;
const COMPACT_PREVIEW_BOTTOM_PADDING = 28;
const COMPACT_PREVIEW_CURRENT_DOT_SIZE = 9;
const COMPACT_PREVIEW_DOT_SIZE = 7;
export interface TimelineCompactPreviewProps {
    periods: TimelinePeriodType[];
}
export function TimelineCompactPreview({ periods, }: TimelineCompactPreviewProps): ReactElement | null {
    if (periods.length === 0) {
        return null;
    }
    const previewPeriods = periods.slice(0, COMPACT_PREVIEW_PERIOD_LIMIT);
    const currentPreviewIndex = Math.floor(previewPeriods.length / 2);
    return (
      <div data-el="Cmarkdowntimeline/TimelineCompactPreview/Root" style={{
            position: "relative",
            display: "flex",
            alignItems: "center",
            height: "100%",
            padding: `0 ${COMPACT_PREVIEW_TRACK_INSET}px ${COMPACT_PREVIEW_BOTTOM_PADDING}px`,
        }}>
        <div style={{
            position: "absolute",
            left: COMPACT_PREVIEW_TRACK_INSET,
            right: COMPACT_PREVIEW_TRACK_INSET,
            height: 1,
            backgroundImage: "linear-gradient(90deg, #66FEC1, #93D8FF)",
            pointerEvents: "none",
        }}/>
        <div style={{
            display: "flex",
            justifyContent: "space-between",
            width: "100%",
            position: "relative",
            zIndex: 1,
        }}>
          {previewPeriods.map((period, periodIndex) => {
            const isCurrent = periodIndex === currentPreviewIndex;
            const isPast = periodIndex < currentPreviewIndex;
            const dotSize = isCurrent
                ? COMPACT_PREVIEW_CURRENT_DOT_SIZE
                : COMPACT_PREVIEW_DOT_SIZE;
            return (<div key={`compact-period-${period.globalIndex}`} style={{
                    width: dotSize,
                    height: dotSize,
                    borderRadius: "50%",
                    flexShrink: 0,
                    backgroundColor: isCurrent
                        ? "#66FEC1"
                        : isPast
                            ? "rgba(255,255,255,0.3)"
                            : "transparent",
                    boxShadow: isCurrent
                        ? "0 0 0 4px rgba(102,254,193,0.15), 0 0 8px rgba(102,254,193,0.4)"
                        : !isPast
                            ? "inset 0 0 0 1.5px rgba(102,254,193,0.45)"
                            : undefined,
                }}/>);
        })}
        </div>
      </div>
    );
}
